import { makeAutoObservable } from "mobx";
import {
  validateEntries,
  validateSubEntrySections,
} from "../domains/dataEntry.validation";

class ValidationStore {
  errors = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  validateEntries = (entries, inputType, options = {}) => {
    const errorsMap = validateEntries(entries, inputType, options);
    this.errors = errorsMap || new Map();
    return !errorsMap;
  };

  validateSubEntrySections = (sections, subEntryDefs, options = {}) => {
    const errorsMap = validateSubEntrySections(sections, subEntryDefs, options);
    this.errors = errorsMap || new Map();
    return !errorsMap;
  };

  clearEntryFieldError = (entryId, field) => {
    if (!entryId || !field) return;

    const fieldErrors = this.errors.get(entryId);
    if (!fieldErrors?.[field]) return;

    const nextErrors = new Map(this.errors);
    const nextFieldErrors = { ...fieldErrors };
    delete nextFieldErrors[field];

    if (Object.keys(nextFieldErrors).length === 0) {
      nextErrors.delete(entryId);
    } else {
      nextErrors.set(entryId, nextFieldErrors);
    }

    this.errors = nextErrors;
  };

  clearErrors = () => (this.errors = new Map());

  reset = () => {
    this.errors = new Map();
  };
}

export const validationStore = new ValidationStore();
